import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-category",
  "use": "medexpert-category-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-category\">\r\n<path fill=\"currentColor\" d=\"M0 6C0 4.89543 0.895431 4 2 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V6Z\" />\r\n<path d=\"M2 2C2 0.895431 2.89543 0 4 0H12C13.1046 0 14 0.895431 14 2H2Z\" fill=\"#C6C8D5\" />\r\n<path d=\"M8.63742 6.28613H13.7716V13.7148L11.2234 11.2497L8.63742 13.7148V6.28613Z\" fill=\"#FBFBFB\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol